import React, { useEffect, useState } from 'react';

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import { onAuthStateChanged } from 'firebase/auth';

import { auth, db } from './components/firebase-config';

import { doc, getDoc } from 'firebase/firestore';

import LoginForm from './components/LoginForm';

import SignUpForm from './components/SignUpForm';

import EmployerFeed from './components/EmployerFeed';

import EmployeeFeed from './components/EmployeeFeed';

import Profile from './components/Profile';

import AuthPage from './components/AuthPage';

import EmployeeSetup from './components/EmployeeSetup';

import EmployerSetup from './components/EmployerSetup';

import RoleSelection from './components/RoleSelection';

import ChatPage from './components/ChatPage';

import Applicants from './components/Applicants';

import AddJob from './components/AddJob';

import LoadingSpinner from './components/LoadingSpinner';

import ActiveApplications from './components/ActiveApplications';

import BottomNav from './components/BottomNav';



const App = () => {

  const [user, setUser] = useState(null); // Keep track of logged-in user

  const [accountType, setAccountType] = useState(null); // Store account type (employer/employee)

  const [loading, setLoading] = useState(true);



  useEffect(() => {

    const unsubscribe = onAuthStateChanged(auth, async (user) => {

      setUser(user);

      if (user) {

        try {

          const employeeDoc = await getDoc(doc(db, 'employees', user.uid));

          const employerDoc = await getDoc(doc(db, 'employers', user.uid));

          

          if (employeeDoc.exists()) {

            setAccountType('employee');

          } else if (employerDoc.exists()) {

            setAccountType('employer');

          } else {

            setAccountType(null); // Explicitly set to null for new users

          }

        } catch (error) {

          console.error('Error checking account type:', error);

          setAccountType(null);

        } finally {

          setLoading(false); // Always set loading to false after Firestore check

        }

      } else {

        setAccountType(null);

        setLoading(false); // Set loading to false if no user

      }

    });



    // Listen for changes in Firestore for the user's role document

    let unsubscribeEmployee = null;

    let unsubscribeEmployer = null;

    if (auth.currentUser) {

      const employeeDocRef = doc(db, 'employees', auth.currentUser.uid);

      const employerDocRef = doc(db, 'employers', auth.currentUser.uid);

      import('firebase/firestore').then(({ onSnapshot }) => {

        unsubscribeEmployee = onSnapshot(employeeDocRef, (docSnap) => {

          if (docSnap.exists()) {

            setAccountType('employee');

            setLoading(false);

          }

        });

        unsubscribeEmployer = onSnapshot(employerDocRef, (docSnap) => {

          if (docSnap.exists()) {

            setAccountType('employer');

            setLoading(false);

          }

        });

      });

    }



    return () => {

      unsubscribe();

      if (unsubscribeEmployee) unsubscribeEmployee();

      if (unsubscribeEmployer) unsubscribeEmployer();

    };

  }, []);



  if (loading) {

    return <LoadingSpinner />;

  }



  // Helper function to wrap protected routes with BottomNav

  const ProtectedRoute = ({ element: Element }) => {

    if (!user) return <Navigate to="/login" />;

    return (

      <>

        <Element />

        <BottomNav accountType={accountType} />

      </>

    );

  };



  return (

    <Router>

      <Routes>

        {/* Public routes */}

        <Route path="/login" element={user ? <Navigate to="/job-feed" /> : <AuthPage />} />

        <Route path="/signup" element={user ? <Navigate to="/job-feed" /> : <AuthPage />} />



        {/* Protected routes with BottomNav */}

        <Route 
          path="/job-feed" 
          element={
            user ? (
              <ProtectedRoute 
                element={accountType === "employer" ? EmployerFeed : EmployeeFeed} 
              />
            ) : (
              <Navigate to="/login" />
            )
          } 
        />
        <Route 
          path="/messages" 
          element={<ProtectedRoute element={ChatPage} />} 
        />
        <Route 
          path="/profile" 
          element={<ProtectedRoute element={Profile} />} 
        />
        <Route 
          path="/add-job" 
          element={
            user && accountType === 'employer' ? 
            <ProtectedRoute element={AddJob} /> : 
            <Navigate to="/job-feed" />
          } 
        />



        {/* Setup routes without BottomNav */}

        <Route 
          path="/employee-setup" 
          element={
            user && !accountType ? <EmployeeSetup /> : 
            <Navigate to="/job-feed" />
          } 
        />
        <Route 
          path="/employer-setup" 
          element={
            user && !accountType ? <EmployerSetup /> : 
            <Navigate to="/job-feed" />
          } 
        />
        <Route 
          path="/role-selection" 
          element={
            user && !accountType ? <RoleSelection /> : 
            <Navigate to="/job-feed" />
          } 
        />



        {/* Other protected routes with BottomNav */}

        <Route 
          path="/applicants" 
          element={
            user && accountType === 'employer' ? 
            <ProtectedRoute element={Applicants} /> : 
            <Navigate to="/job-feed" />
          } 
        />
        <Route 
          path="/active-applications" 
          element={
            user && accountType === 'employee' ? 
            <ProtectedRoute element={ActiveApplications} /> : 
            <Navigate to="/job-feed" />
          } 
        />



        {/* Fallback Route */}

        <Route path="*" element={<Navigate to={user ? "/job-feed" : "/login"} />} />



      </Routes>

    </Router>

  );

};



export default App;
